import {NgModule} from "@angular/core";
import {RouterModule, Routes} from "@angular/router";
import {DashboardComponent} from "./admin/dashboard/dashboard.component";
import {SigninComponent} from "./admin/signin/signin.component";
import {SignoutComponent} from "./admin/signout/signout.component";
import {SignupComponent} from "./admin/signup/signup.component";
import {ListChannelsComponent} from "./admin/channels/list/list.component";
import {AdminChannelsViewChannelComponent} from "./admin/channels/view/view.component";
import {CheckAuthGuard} from "./services/check-auth.guard";
import {DecisionsComponent} from "./admin/decisions/decisions.component";
import {TenantsComponent} from "./admin/tenants/tenants.component";
import {AdminLookupScreeningComponent} from "./admin/lookup/screening/screening.component";
import {AdminLookupScoringComponent} from "./admin/lookup/scoring/scoring.component";
import {AdminLayoutStandardComponent} from "./admin/templates/layout/standard/standard.component";
import {AdminLayoutMinimalComponent} from "./admin/templates/layout/minimal/minimal.component";
import {AdminLookupMonitoringComponent} from "./admin/lookup/monitoring/monitoring.component";
import {AdminLookupCommonShareComponent} from "./admin/lookup/common/share/share.component";
import {AdminResultsCasesComponent} from "./admin/results/cases/cases.component";
import {AdminResultsCaseViewComponent} from "./admin/results/cases/view/view.component";

export const routes: Routes = [
  // Root redirect
  {
    path: '',
    redirectTo: 'admin',
    pathMatch: 'full'
  },

  // --- Minimal layout routes ---
  {
    path: 'signin',
    component: AdminLayoutMinimalComponent,
    children: [{ path: '', component: SigninComponent }]
  },
  {
    path: 'signout',
    component: AdminLayoutMinimalComponent,
    children: [{ path: '', component: SignoutComponent }]
  },
  {
    path: 'signup',
    component: AdminLayoutMinimalComponent,
    children: [{ path: '', component: SignupComponent }]
  },

  // --- Token route (no redirect) ---
  // {
  //   path: 'token',
  //   component: class { },
  //   data: { persistence: true },
  // },

  // --- Admin (business) routes ---
  {
    path: 'admin',
    component: AdminLayoutStandardComponent,
    canActivateChild: [CheckAuthGuard],
    children: [
      { path: '', component: DashboardComponent },
      { path: 'dashboard', component: DashboardComponent },

      // Channels
      { path: 'channels', component: ListChannelsComponent },
      { path: 'channel/:owner/:vertical/:code', component: AdminChannelsViewChannelComponent },

      // Tenants
      { path: 'tenants', component: TenantsComponent },

      // Decisions
      { path: 'decisions', component: DecisionsComponent },

      // Lookup
      {
        path: 'lookup',
        component: AdminLookupCommonShareComponent,
        children: [
          { path: 'screening', component: AdminLookupScreeningComponent },
          { path: 'scoring', component: AdminLookupScoringComponent },
          { path: 'monitoring', component: AdminLookupMonitoringComponent }
        ]
      },

      // Results
      {
        path: 'results',
        children: [
          { path: "cases", component: AdminResultsCasesComponent },
          { path: "case/view/:internal", component: AdminResultsCaseViewComponent },
        ]
      },

      // Any unknown /admin/... → redirect to /signin
      { path: '**', redirectTo: '/signin' }
    ]
  },

  // --- Global fallback ---
  {
    path: '**',
    redirectTo: 'admin',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { enableTracing: false })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
